import { useState } from "react";
import { message } from "antd";

import { Dialog, DialogTitle, DialogActions } from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { showErrorToast } from "V2.0/utils";

export default WebhookDelete;

function WebhookDelete(props) {
  const { webhook, onClose, onWebhookDelete } = props;

  const [loading, setLoading] = useState(false);

  const handleDelete = () => {
    const init = () => {
      setLoading(true);
      message.loading("Deleting Webhook");
    };

    const success = () => {
      message.destroy();
      message.success("Webhook deleted");
      setLoading(false);
      onClose();
    };

    const error = (e: any) => {
      setLoading(false);
      message.destroy();
      showErrorToast(e, "Failed to delete Webhook");
    };

    onWebhookDelete(webhook._id, { init, success, error });
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>Delete {webhook.webhookName}?</DialogTitle>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          loading={loading}
          disabled={loading}
          onClick={handleDelete}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
